import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
    selector: 'app-data-integration',
    templateUrl: './data-integration.component.html',
    styleUrls: ['./data-integration.component.scss']
})
export class DataIntegrationComponent implements OnInit {

    @Input() public user: any;

    constructor() { }

    ngOnInit() {
    }

}
